import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";

const Shares = lazy(() => import("Shares"));
const Signage = lazy(() => import("Signage"));
const Numbers = lazy(() => import("Numbers"));
const Website = lazy(() => import("Website"));
const People = lazy(() => import("People"));
const SupportVisits = lazy(() => import("SupportVisits"));
const Financials = lazy(() => import("Financials"));
const Home = lazy(() => import("Home"));

function Routes() {
  return (
    <Suspense fallback>
      <Switch>
        <Route path={["/", "/home"]} exact={true} component={Home} />
        <Route path="/shares" component={Shares} />
        <Route path="/website" component={Website} />
        <Route path="/people" component={People} />
        <Route path="/supportvisits" component={SupportVisits} />
        <Route path="/financials" component={Financials} />
        <Route path="/signage" component={Signage} />
        <Route
          path="/numbers/:locType?/:locID?/:startDate?/:endDate?/:tab?/:customReportID?"
          component={Numbers}
        />
      </Switch>
    </Suspense>
  );
}

export default Routes;
